<template>
  <path fill-rule="evenodd" d="M73.025.687C64.812.456 18.127 2.556 9.74 12.382-1.971 26.1-1.784 44.573 7.669 53.732c10.975 10.634 49.525 15.06 59.193 15.333 6.313.178 48.188 2.717 60.453-7.247 8.614-6.998 8.435-25.225-.397-39.754C118.2 6.074 78.584.844 73.025.687z"/>
</template>

<script>
export default {

}
</script>



// WEBPACK FOOTER //
// components/_SVG/ShapeYearBtn2Mob.vue